import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import './style.scss';

function DatePicker({
  onChange = () => {},
  selectedDate = new Date(),
  className = '',
  disabled = false,
  ...rest
}) {
  return (
    <div className={`tv-datepicker ${className}`}>
      <ReactDatePicker
        dateFormat="yyyy-MM-dd"
        selected={selectedDate}
        onChange={onChange}
        locale="sv"
        calendarStartDay={1}
        readOnly={disabled}
        {...rest}
      />
      <span className="tv-datepicker__icon material-icons">&#xe935;</span>
    </div>
  );
}

DatePicker.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  selectedDate: PropTypes.shape({}),
  disabled: PropTypes.bool,
};

export default DatePicker;
